import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './reducers';

export default function configureStore(initState) {
  const composeEnhancers = composeWithDevTools({
    name: 'ra-landlord-web-ssr',
    trace: process.env.NODE_ENV !== 'production',
  });
  const store = createStore(rootReducer, initState, composeEnhancers(applyMiddleware(thunk)));

  return store;
}
